import { render, staticRenderFns } from "./app-search-card.vue?vue&type=template&id=1c3cb790&scoped=true&"
import script from "./app-search-card.vue?vue&type=script&lang=js&"
export * from "./app-search-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3cb790",
  null
  
)

export default component.exports